"use client";

import React from "react";
import { Instagram, Music, Disc } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VisualIdentity() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  return <section data-section-id="35143" id="welcome-to-ai-looks-at-ai" className="relative min-h-screen w-full bg-[#fc6e51] text-[#ea0f0f] overflow-hidden pt-12 pb-24 flex flex-col items-center">
      {}
      <div className="flex items-center justify-center gap-8 mb-12 md:mb-20 z-10">
        <Link to="/HomePage" className="text-[#ea0f0f] hover:text-white transition-colors duration-300" aria-label="Home">
          <Disc className="w-6 h-6" strokeWidth={1.5} />
        </Link>
        <Link to="https://instagram.com" newTab className="text-[#ea0f0f] hover:text-white transition-colors duration-300" aria-label="Instagram">
          <Instagram className="w-6 h-6" strokeWidth={1.5} />
        </Link>
        <Link to="https://music.apple.com" newTab className="text-[#ea0f0f] hover:text-white transition-colors duration-300" aria-label="Apple Music">
          <Music className="w-6 h-6" strokeWidth={1.5} />
        </Link>
      </div>

      {}
      <div className="w-full max-w-7xl px-4 md:px-8 grid grid-cols-1 md:grid-cols-[1fr_1.5fr_1fr] gap-4 md:gap-8 items-start mb-16 md:mb-24">
        {}
        <div className="w-full group overflow-hidden">
          <AspectRatio ratio={4 / 5}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597246/img/alan_f_harrison.png" alt="Alan F Harrison portrait" className="w-full h-full object-cover rounded-full border-4 border-[#ea0f0f] transition-transform duration-700 ease-out group-hover:scale-105" />
          </AspectRatio>
        </div>

        {}
        <div className="w-full group overflow-hidden md:mt-10">
          <AspectRatio ratio={3 / 2}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597246/img/robot_hercules.png" alt="Hercules AI Robot Illustration" className="w-full h-full object-cover rounded-sm transition-transform duration-700 ease-out group-hover:scale-105" />
          </AspectRatio>
        </div>

        {}
        <div className="w-full group overflow-hidden">
          <AspectRatio ratio={4 / 5}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597246/img/ai_visual_concept.png" alt="AI Data Visualization" className="w-full h-full object-cover rounded-sm transition-transform duration-700 ease-out group-hover:scale-105" />
          </AspectRatio>
        </div>
      </div>

      {}
      <div ref={textRef} className={cn("text-center flex flex-col items-center transition-all duration-1000 ease-out transform px-4", isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20")}>
        <h1 className="font-sans font-bold text-[8vw] leading-[1.1] tracking-tight uppercase text-[#ea0f0f] select-none">
          Welcome to 'AI looks at AI'
        </h1>
        <p className="mt-6 md:mt-10 font-sans text-sm md:text-lg tracking-[0.1em] uppercase text-[#ea0f0f] max-w-2xl">
          Alan F Harrison — AI Presenter and Educator. Join us on a journey to demystify artificial intelligence.
        </p>
      </div>
    </section>;
}